/**
 * IPC gestiones of CRM Postventa › Gestión: the "Nueva gestión" types and motives, the motive code of a gestión
 * and what the IPC tab hides.
 *
 * IPC without paper rolls (S8a). Rollo requests are handled in the Rollo section, so the IPC tab hides the
 * legacy gestiones whose motive is rollos and no longer offers the "Rollos" motive. The gestiones stay in
 * the database and the shared backend payload is unchanged: only what the IPC tab renders is filtered.
 */

/** Motive codes of the legacy rollo gestiones (manual, automatic alert rule and its reason key, IPC Consulta). */
export const ROLLO_MOTIVO_CODES = Object.freeze(["MAN_ROLLOS", "FALTA_ROLLOS", "AUTO_FALTA_ROLLOS", "MAN_IPC_CONSULTA_ROLLOS"]);

const ROLLO_MOTIVO_CODE_SET = new Set(ROLLO_MOTIVO_CODES);

/** IPC "Nueva gestión" motives by Tipo IPC. "Rollos" was removed from Consulta. */
export const GESTION_IPC_REASON_OPTIONS = {
  Modificacion: ["Datos bancarios", "Datos fiscales", "Titularidad", "Domicilio", "Datos de terminal", "Otros"],
  Reclamo: ["Liquidacion", "Servicio tecnico", "Configuracion terminal", "Plazos de acreditacion", "Panel central"],
  Consulta: ["Tasas", "Plazos de acreditacion", "Operativa", "Simuladores", "Ordenes de pago", "Consultas especificas"],
};

/** Tipo IPC options, in the order above: every type has its motives. */
export const GESTION_IPC_TYPES = Object.keys(GESTION_IPC_REASON_OPTIONS);

/**
 * Motive code of a gestión, trimmed and upper-cased: the persisted motive code (camelCase or PascalCase), then the
 * rule code. The IPC scope of a gestión and the rollo filter both read it, so the precedence lives only here.
 */
export const resolveMotivoCodigo = (gestion) =>
  String(gestion?.motivoCodigo || gestion?.MotivoCodigo || gestion?.nombreAccion || "").trim().toUpperCase();

export const isRolloGestion = (gestion) => ROLLO_MOTIVO_CODE_SET.has(resolveMotivoCodigo(gestion));

export const filterIpcGestiones = (list) => (Array.isArray(list) ? list.filter((gestion) => !isRolloGestion(gestion)) : []);

/**
 * IPC "Última gestión": the backend one when its motive code says it is not a rollo gestión. A rollo gestión, or one
 * without any motive field (nothing tells it is not rollo), gives way to the latest non-rollo gestión of the
 * historial, else null.
 */
export const pickIpcUltimaGestion = (ultimaGestion, historial) => {
  const motivoCodigo = resolveMotivoCodigo(ultimaGestion);
  if (motivoCodigo && !ROLLO_MOTIVO_CODE_SET.has(motivoCodigo)) {
    return ultimaGestion;
  }

  return filterIpcGestiones(historial)[0] || null;
};
